<template>
  <g
    id="Layer_7"
    data-name="Layer 7">
    <path d="m10 11h2v8h2v-8h2v-2h-6z"/><path d="m34 11h2v8h2v-8h2v-2h-6z"/><path d="m18 10v8a1 1 0 0 0 1 1h5v-2h-4v-2h4v-2h-4v-2h4v-2h-5a1 1 0 0 0 -1 1z"/><path d="m26 12a3 3 0 0 0 3 3 1 1 0 0 1 0 2h-3v2h3a3 3 0 0 0 0-6 1 1 0 0 1 0-2h3v-2h-3a3 3 0 0 0 -3 3z"/><path d="m7 23h36a1 1 0 0 0 1-1v-16a1 1 0 0 0 -1-1h-36a1 1 0 0 0 -1 1v16a1 1 0 0 0 1 1zm1-16h34v14h-34z"/><path d="m6 35h6a1 1 0 0 0 1-1v-5.59l2.71-2.7-1.42-1.42-2.7 2.71h-5.59a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1zm5-2h-2.59l2.59-2.59zm-1.41-4-2.59 2.59v-2.59z"/><path d="m12 47h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"/><path d="m13.29 35.29-1.7 1.71h-5.59a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5.59l1.71-1.7zm-3.7 3.71-2.59 2.59v-2.59zm1.41 4h-2.59l2.59-2.59z"/><path d="m15 28h29v2h-29z"/><path d="m15 48h13v2h-13z"/><path d="m15 52h29v2h-29z"/><path d="m62.71 22.29-4-4a1 1 0 0 0 -1.42 0l-8.29 8.3v-24.59a1 1 0 0 0 -1-1h-46a1 1 0 0 0 -1 1v60a1 1 0 0 0 1 1h46a1 1 0 0 0 1-1v-24.59l13.71-13.7a1 1 0 0 0 0-1.42zm-28.37 22.46 1.91 1.91-3.35 1.44zm1.07-1.75 18.59-18.59 2.59 2.59-18.59 18.59zm11.59 18h-44v-58h44v25.59l-3.41 3.41h-28.59v2h26.59l-4 4h-22.59v2h20.59l-2 2h-18.59v2h17.48l-2.4 5.61a1 1 0 0 0 .92 1.39 1 1 0 0 0 .39-.08l7-3a1.11 1.11 0 0 0 .32-.21l8.29-8.3zm11-35.41-2.59-2.59 2.59-2.59 2.59 2.59z"/>
  </g>
</template>

<script>
export default {
  data() {
    return {
      viewBox: '0 0 64 64',
    };
  },
};
</script>

<style scoped>

</style>
